import createReducer from 'reducers/createReducer';

import { SystemSetting } from 'actions/actionTypes';

const INITIAL_STATE = {
    settingGroups: [],
    systemSettingList: {},
    error: {
        triggered: false,
        message: '',
    },
};

// 리듀서
const reducer = createReducer(INITIAL_STATE, {
    [SystemSetting.LOAD_SYSTEM_SETTING_LIST_REQUEST]: (state, action) => {
        state.error = INITIAL_STATE.error;

        state.settingGroups = action.payload;
    },
    [SystemSetting.LOAD_SYSTEM_SETTING_LIST_REQUEST_SUCCESS]: (state, action) => {
        action.payload.forEach((item) => {
            state.systemSettingList[item.data.settingGroup] = item.data.list;
        });
    },
    [SystemSetting.LOAD_SYSTEM_SETTING_LIST_REQUEST_FAILURE]: (state, action) => {
        state.error = {
            triggered: true,
            message: action.payload.errorMessage,
        };
    },
});

export default reducer;
